import type { VariantProps } from 'class-variance-authority';

import type { badgeVariants } from '#src/app/shared/components/adminShadcn';

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>;

type Result = ModelHookResult<{
	variant: BadgeVariant;
}>;

export function useStatusBadge({ status }: { status: string }): Result {
	return {
		data: {
			variant: getVariant(status),
		},
	};
}

function getVariant(status: string): BadgeVariant {
	if (['SENT', 'SCHEDULED', 'RECOMMENDATIONS_FINISHED'].includes(status)) {
		return 'success';
	}
	if (status === 'ERROR') {
		return 'error';
	}
	if (status === 'DRAFT') {
		return 'gray';
	}
	return 'gray';
}
